interface LabelType {
  en?: string;
  de?: string;
  fr?: string;
  it?: string;
}

interface Messages {
  [key: string]: string;
}

export type LocaleType = 'en' | 'de' | 'fr' | 'it';

const createFallback = (messages: Messages) => {
  let fallback = '';

  for (const message in messages) {
    fallback += `/${messages[message]}`;
  }

  return fallback.slice(1);
};

export const getTranslation = (
  text: LabelType | string | undefined,
  locale: LocaleType
) => {
  if (!text) return '';

  // text as string
  if (typeof text === 'string') return text;

  // text as object with translations
  const translatedString = text[locale];
  if (translatedString) return translatedString;

  // when there is no available translation, app will look for message in English.
  // If it's not available it will use phrase in all of the languages provided separated by '/'
  const fallbackMessage = createFallback(text as Messages);

  return text['en']
    ? text['en']
    : fallbackMessage
    ? fallbackMessage
    : 'Missing translations';
};
